import { lazy } from "react";
import Loadable from "components/Loadable";

const PageList = Loadable(
  lazy(() => import("features/page/components/List"))
);
const PageForm = Loadable(
  lazy(() => import("features/page/components/Page"))
);

const routes = {
  path: "page",
  children: [
    { path: "", element: <PageList /> },
    { path: "add", element: <PageForm /> },
    { path: "edit/:pageID?", element: <PageForm /> },
  ],
};

export default routes;
